module.exports = __webpack_public_path__ + "static/media/icita2019.ea31e8b2.PNG";